import {isLocalApi} from 'src/env'
import {restAPIServiceTranslates} from './service';
import {localAPIServiceTranslates} from './serviceLocal'

const APIServiceTranslates = isLocalApi ? localAPIServiceTranslates : restAPIServiceTranslates;
APIServiceTranslates.init();

export default APIServiceTranslates;
